// extracted by mini-css-extract-plugin
module.exports = {"base":"_6b0e646"};